import { render, staticRenderFns } from "./myorder.vue?vue&type=template&id=114b2a40&scoped=true"
import script from "./myorder.vue?vue&type=script&lang=js"
export * from "./myorder.vue?vue&type=script&lang=js"
import style0 from "./myorder.vue?vue&type=style&index=0&id=114b2a40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114b2a40",
  null
  
)

export default component.exports